import { IBarChartSettingsValue } from './barChartSettingsValue';

const DEFAULT_SETTINGS = {
	mainColor: '#FF8D4F',
	secondaryColor: '#C3C3C3',
	count: 15
}

export class BarChartSettings {
	mainColor: string = DEFAULT_SETTINGS.mainColor;
	secondaryColor: string = DEFAULT_SETTINGS.secondaryColor;
	count: number = DEFAULT_SETTINGS.count;
	defaultMetric: string = '';

	constructor(settings?: IBarChartSettingsValue) {
		if (!settings) return;
		if (settings.mainColor) this.mainColor = settings.mainColor;
		if (settings.secondaryColor) this.secondaryColor = settings.secondaryColor;
		if (settings.count) this.count = settings.count;
		if (settings.defaultMetric) this.defaultMetric = settings.defaultMetric;
	}
}